import { ILiveCategoryLinkActionPayload } from '../interfaces/live-category-link.action-payload.interface';

export class CreateLiveCateogryLinkCommand {
    audience_id: number;
    featured_stream_id: number;
    category_ids: number[];

    constructor(query: ILiveCategoryLinkActionPayload) {
        this.audience_id = Number(query.audience.id);
        this.featured_stream_id = Number(query.featuredStream.id);
        this.category_ids = query.categoryIds;
    }
}
